import React, { useEffect, useState } from 'react'
import { Form } from '@wework/dieter-ui'
import { Search } from 'semantic-ui-react'
import { Label } from 'semantic-ui-react'

export default function AutoCompleteTextField({
  placeholder,
  id,
  onChange,
  required,
  value,
  label,
  disabled,
  dataSource,
  defaultSelectedItem,
  testID,
  suggestions,
}: any) {
  const [inputValue, setInputValue] = useState('')
  // const [suggestions, setSuggestions] = useState(initialState)
  useEffect(() => {
    setInputValue(value)
    return () => {
      setInputValue('')
    }
  }, [value])
  //@ts-ignore
  const resultRenderer = item => (
    <Label content={`${item.contact_info_email} - ${item.contact_info_name}`} />
  )

  return (
    <Form.Field
      style={{ borderRadius: 0, width: '100%' }}
      icon={null}
      // loading={isLoading}
      disabled={disabled}
      label={label}
      outline
      placeholder={placeholder}
      // width={8}
      // onResultSelect={handleChange}
      onResultSelect={(e, data) => {
        onChange(data.result.contact_info_email)
        setInputValue(data.result.contact_info_email)
      }}
      // onSearchChange={_.debounce(this.handleSearchChange, 500, {
      //   leading: true,
      // })}
      onSearchChange={(e, { value }) => {
        if (value) {
          dataSource(value)
        }
        return value && setInputValue(value)
      }}
      resultRenderer={resultRenderer}
      results={suggestions}
      value={inputValue}
      control={Search}
    />
  )
}
